import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBuilding, FaUsers, FaCalendarAlt, FaClock, FaBookOpen } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import { useInsights } from '../../../hooks/useInsights';
import { useRecentBookings } from '../../../hooks/useBookings';
import { Button } from 'antd';
import { useGetUserData } from '../../../hooks/useGetUserData';
import drEasyApi from '../../../Api/Customapi';
import { FiEyeOff } from 'react-icons/fi';
import { BsEye } from 'react-icons/bs';

const Dashboard = () => {
    const { data: user, isLoading, refetch } = useGetUserData();

    const navigate = useNavigate();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { data: insights, isLoading: insightsLoading, error: insightsError } = useInsights();
    const { data: recentBookings, isLoading: bookingsLoading, error: bookingsError } = useRecentBookings(isMobile ? 3 : 5);

    const Card = ({ children, className = '', onClick }) => (
        <div className={`bg-white rounded-lg border shadow-sm ${className} ${onClick ? 'cursor-pointer hover:shadow-md transition-all' : ''}`} onClick={onClick}>
            {children}
        </div>
    );
    console.log('=============user=======================');
    console.log(user);
    console.log('====================================');
    const CardHeader = ({ children, className = '' }) => <div className={`p-4 ${className}`}>{children}</div>;

    const CardTitle = ({ children, className = '' }) => <h3 className={`font-medium ${className}`}>{children}</h3>;

    const CardContent = ({ children, className = '' }) => <div className={`p-4 ${className}`}>{children}</div>;

    const PageTitle = ({ title, subtitle }) => (
        <div className="mb-6">
            <h1 className="text-2xl font-bold">{title}</h1>
            <p className="text-gray-500">{subtitle}</p>
        </div>
    );

    const formatBookingDateTime = (bookingDate, startTime) => {
        const date = new Date(bookingDate);
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        let dateStr = date.toDateString() === today.toDateString()
            ? 'Today'
            : date.toDateString() === tomorrow.toDateString()
                ? 'Tomorrow'
                : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

        const timeStr = new Date(`1970-01-01T${startTime}`).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        return `${dateStr}, ${timeStr}`;
    };
console.log(insights);

    const stats = [
        {
            title: "Total Clinics",
            value: insights?.totalClinics || "0",
            icon: <FaBuilding className="h-5 w-5 text-blue-500" />,
            change: (
                <div className="space-y-1 text-xs text-gray-500">
                    <div>+{insights?.gainedClinicsThisMonth || 0} this month</div>
                </div>
            ),
            onClick: () => navigate("/clinics")
        },
        {
            title: "Patients",
            value: insights?.totalPatients || "0",
            icon: <FaUsers className="h-5 w-5 text-green-500" />,
            change: (
                <div className="space-y-1 text-xs text-gray-500">
                    <div>+{insights?.
                        newPatientsThisWeek
                    } this week</div>
                    <div>+{insights?.newPatientsThisMonth
                    } this month</div>
                    <div>+{insights?.newPatientsToday} this day</div>
                </div>
            ),
            onClick: () => navigate("/patients")
        },
        {
            title: "Bookings",
            value: insights?.totalBookings || "0",
            icon: <FaCalendarAlt className="h-5 w-5 text-yellow-500" />,
            change: (
                <div className="space-y-1 text-xs text-gray-500">
                    <div>+{insights?.bookingsToday || 0} today</div>
                    <div>+{insights?.bookingsThisWeek || 0} this week</div>
                    <div>+{insights?.bookingsThisMonth || 0} this month</div>
                </div>
            ),
            onClick: () => navigate("/bookings")
        },
        {
            title: "Available Hours",
            value: insights?.totalAvailabilityHours || "0",
            icon: <FaClock className="h-5 w-5 text-purple-500" />,
            change: (
                <div className="text-xs text-gray-500">across all clinics</div>
            ),
            onClick: () => navigate("/schedule")
        },
    ];
    const toggleOverView = async () => {
        await drEasyApi.put("/api/Doctor/toggle-my-overview")
        refetch()
    }
    if (insightsLoading || bookingsLoading) {
        return (
            <div className="p-6 flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (insightsError || bookingsError) {
        return (
            <div className="p-6">
                {insightsError && (
                    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
                        <p className="text-sm text-red-700">{insightsError.message}</p>
                    </div>
                )}
                {bookingsError && (
                    <div className="bg-red-50 border-l-4 border-red-500 p-4">
                        <p className="text-sm text-red-700">{bookingsError.message}</p>
                    </div>
                )}
            </div>
        );
    }


    return (
        <div className="animate-fade-in">
            <div className='flex justify-between flex-col md:flex-row'>

                <PageTitle title="Welcome to DrEasy" subtitle="Here's what's happening across your clinics" />

                <button type='text' className={`border border-1 p-0 h-9 mb-5 hover:bg-primary/40 py-2 px-1 md:px-3 rounded-xl text-xs md:text-sm  border-black/20 ${user?.showOverView ? "bg-primary text-white hover:text-white" : "bg-white text-black"} mt-5 me-4 flex items-center justify-center gap-2`} onClick={toggleOverView}>   {user?.showOverView ? <FiEyeOff size={17} className=" text-white" /> : <BsEye size={17} className="text-black" />}
                    {user?.showOverView ? "Hide OverView From patients" : "Show Overview"}</button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {stats.map((stat, index) => (
                    <Card key={index} onClick={stat.onClick}>
                        <CardHeader className="flex flex-row items-center justify-between pb-2">
                            <CardTitle className="text-sm font-medium text-gray-500">{stat.title}</CardTitle>
                            {stat.icon}
                        </CardHeader>
                        <CardContent>
                            <div className="text-2xl font-bold">{stat.value}</div>
                            <div className="mt-1">{stat.change}</div>
                        </CardContent>
                    </Card>
                ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
                <Card className="col-span-2">
                    <CardHeader>
                        <div className="flex items-center justify-between">
                            <CardTitle className="text-lg">Recent Bookings</CardTitle>
                            <FaBookOpen className="h-4 w-4 text-gray-400" />
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-4">
                            {recentBookings.map((booking) => (
                                <div
                                    key={booking.id}
                                    className="flex items-center p-3 bg-white border rounded-lg hover:bg-gray-50 transition-colors"
                                >
                                    <div className="flex-1">
                                        <h4 className="font-medium">{booking.patientName}</h4>
                                        <p className="text-sm text-gray-500">{booking.clinicName}</p>
                                    </div>
                                    <div className="flex-1 text-sm">
                                        {formatBookingDateTime(booking.bookingDate, booking.startTime)}
                                    </div>
                                    <div>
                                        <span
                                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                                            ${booking.status.toLowerCase() === 'confirmed'
                                                    ? 'bg-green-100 text-green-800'
                                                    : booking.status.toLowerCase() === 'pending'
                                                        ? 'bg-yellow-100 text-yellow-800'
                                                        : 'bg-red-100 text-red-800'
                                                }`}
                                        >
                                            {booking.status.charAt(0).toUpperCase() + booking.status.slice(1).toLowerCase()}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="mt-4 text-center">
                            <button
                                className="text-blue-500 text-sm font-medium hover:underline"
                                onClick={() => navigate("/bookings")}
                            >
                                View all bookings
                            </button>
                        </div>
                    </CardContent>
                </Card>

                <Card className="lg:col-span-1 col-span-2">
                    <CardHeader>
                        <CardTitle className="text-lg">Quick Actions</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-4">
                            {/* <button
                                className="w-full flex items-center p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                                onClick={() => navigate("/clinics")}
                            >
                                <FaBuilding className="h-5 w-5 text-blue-500 mr-3" />
                                <span className="font-medium">Add New Clinic</span>
                            </button>
                            <button
                                className="w-full flex items-center p-3 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
                                onClick={() => navigate("/schedule")}
                            >
                                <FaCalendarAlt className="h-5 w-5 text-green-500 mr-3" />
                                <span className="font-medium">Manage Working Days</span>
                            </button> */}
                            <button
                                className="w-full flex items-center p-3 bg-yellow-50 rounded-lg hover:bg-yellow-100 transition-colors"
                                onClick={() => navigate("/form-builder")}
                            >
                                <FaUsers className="h-5 w-5 text-yellow-500 mr-3" />
                                <span className="font-medium">Create Patient Form</span>
                            </button>
                            <button
                                className="w-full flex items-center p-3 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors"
                                onClick={() => navigate("/bookings")}
                            >
                                <FaBookOpen className="h-5 w-5 text-purple-500 mr-3" />
                                <span className="font-medium">View All Bookings</span>
                            </button>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default Dashboard;
